/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SearchFiltersSchemaCompanyTagFilterType = typeof SearchFiltersSchemaCompanyTagFilterType[keyof typeof SearchFiltersSchemaCompanyTagFilterType];


export const SearchFiltersSchemaCompanyTagFilterType = {
  c: 'c',
  p: 'p',
  cp: 'cp',
} as const;
